import script from "./ConnectedServicesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectedServicesSection.vue?vue&type=script&setup=true&lang=js"

import "./ConnectedServicesSection.vue?vue&type=style&index=0&id=b8826dc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8826dc2"]])

export default __exports__